import * as SelectPrimitive from "@radix-ui/react-select";
import * as React from "react";

import { cn } from "../../../utils";
import { SelectContext } from "./context";

export function SelectLabel({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof SelectPrimitive.Label>) {
  const ctx = React.useContext(SelectContext);

  if (ctx.isSimple) {
    return (
      <SelectPrimitive.Label
        className={cn(
          "py-1.5 pl-2 pr-2 text-sm font-semibold tracking-wide text-gray-500",
          className,
        )}
        {...props}
      />
    );
  }

  return (
    <div
      className={cn(
        "py-1.5 pl-2 pr-2 text-sm font-semibold tracking-wide text-gray-500",
        className,
      )}
      {...(props as React.HTMLAttributes<HTMLDivElement>)}
    />
  );
}

SelectLabel.displayName = SelectPrimitive.Label.displayName;
